module.exports = __webpack_public_path__ + "static/media/banner.acaa18b1.png";